import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import withParams from "routing/withParams";
import { PageHeader, DocumentTitle } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import TeamDetails from "../components/team-details/TeamDetails";
import TeamsDomain from "../domainActions/TeamsDomain";
import TeamActionLinks from "../components/navigation/TeamActionLinks";
const PageTitle = ({ name }) => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("team_details_page.title"), " ", name && /* @__PURE__ */ React.createElement(React.Fragment, null, "- ", /* @__PURE__ */ React.createElement("i", null, name)));
};
const TeamDetailsPage = ({ params }) => {
  const { t } = useTranslation("enterprise_security");
  const teamId = params == null ? void 0 : params.teamId;
  const [team, setTeam] = useState();
  const name = team == null ? void 0 : team.name;
  useEffect(() => {
    TeamsDomain.load(teamId).then(setTeam);
  }, [teamId]);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("team_details_page.document_title", { name: name != null ? name : "" }) }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(PageTitle, { name }),
      actions: /* @__PURE__ */ React.createElement(TeamActionLinks, { team }),
      documentationLink: {
        title: t("team_details_page.documentation_link"),
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("team_details_page.description"))
  ), /* @__PURE__ */ React.createElement(TeamDetails, { team }));
};
export default withParams(TeamDetailsPage);
